'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = errorMiddleware;

var _isPromise = require('../utils/is-promise');

var _isPromise2 = _interopRequireDefault(_isPromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function errorMiddleware() {
  return function (next) {
    return function (action) {
      var result = next(action);

      if (!(0, _isPromise2.default)(result)) {
        return action;
      }

      return result.catch(function () {});
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/boilerplate/middlewares/error-middleware.js
// module id = 569
// module chunks = 0